<div class="verification-flow">

    <HomeNavBar/>


    <div class="container py-4">
      <div class="mb-4 step-indicator">
        <div class="row justify-content-center">
          <div class="col-auto" v-for="(step, index) in steps" :key="index">
            <div class="step d-flex flex-column align-items-center" :class="{ active: currentStepIndex === index, completed: currentStepIndex > index }">
              <div class="step-circle" :class="currentStepIndex === index ? 'bg-secondary text-white border-primary' : currentStepIndex > index ? 'bg-primary text-white border-success' : 'bg-light text-secondary border border-2'">{{ index + 1 }}</div>
              <div class="step-label" :class="currentStepIndex === index ? 'text-secondary fw-bold' : currentStepIndex > index ? 'text-primary' : 'text-primary'">{{ step.label }}</div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="currentStepIndex === 0" class="step-content bg-white shadow p-4 p-md-5 rounded">
        <h2 class="text-center text-primary mb-4 fw-bold">Choose Your Membership Plan</h2>
        <div class="row g-4 mb-3">
  <div class="col-md-4 d-flex align-items-stretch" v-for="(plan, index) in active_membership_plans" :key="plan.id">
    <div class="w-100 d-flex flex-column align-items-center">

      <!-- Current Plan Badge -->
      <span
        v-if="current_membership && plan.id === current_membership.id"
        class="badge bg-primary fs-6 px-4 py-2 mb-2 rounded-top-3">
        Current Plan
      </span>

      <!-- Membership Plan Card -->
      <div
        class="membership-card border rounded-4 p-4 shadow-sm w-100 d-flex flex-column text-center"
        :class="[
          current_membership && plan.id === current_membership.id
            ? 'border-secondary border-3 bg-light shadow-lg'
            : 'border-2',
          selectedPlan === index && !(current_membership && plan.id === current_membership.id)
            ? 'border-danger shadow-sm'
            : ''
        ]"
        @click="selectPlan(index)"
      >

        <!-- Plan Name -->
        <h4
          class="fw-bold mb-1 text-secondary">
          {{ plan.name }}
        </h4>

        <!-- Price -->
        <div
          class="fs-4 fw-semibold text-primary mb-1"
          :class="{ 'text-primary': current_membership && plan.id === current_membership.id }">
          {{
            (plan.membership_pricing || []).length > 0
              ? 'R ' + Number(plan.membership_pricing[0].price).toLocaleString('en-ZA', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              : 'N/A'
          }}
        </div>

        <!-- Billing cycle -->
        <div class="text-muted small mb-3">
          {{ plan.billing_cycle?.name || '-' }}
        </div>

        <!-- Perk Features -->
        <ul class="list-unstyled text-start mb-4 flex-grow-1">
          <li
            v-for="(feature, i) in plan.membership_perks"
            :key="i"
            class="d-flex align-items-start gap-2 py-2 border-bottom small">
            <i class="bi bi-check-circle-fill text-primary mt-1"></i>
            {{ feature.perk.name }}
          </li>
        </ul>

        <!-- Action Button -->
        <div class="mt-auto">
          <button
            v-if="current_membership && plan.id === current_membership.id"
            class="btn btn-secondary px-4 py-2 rounded-pill fw-semibold shadow-sm"
            disabled>
            Current
          </button>
          <button
            v-else
            class="btn px-4 py-2 rounded-pill fw-semibold"
            :class="selectedPlan === index ? 'btn-primary text-white' : 'btn-secondary'">
            {{ selectedPlan === index ? 'Selected' : 'Select' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>


        <div class="d-flex justify-content-between">
          <button class="btn btn-outline-secondary rounded-pill px-4" @click="cancel">Cancel</button>
          <button class="btn btn-danger rounded-pill px-4"
  :disabled="selectedPlan === null || (current_membership && membershipPlans[selectedPlan]?.id === current_membership.id)"
  @click="nextStep">
  Continue
</button>
        </div>
      </div>


      <div v-if="currentStepIndex === 1" class="step-content bg-white shadow-lg p-4 p-md-5 rounded-5 border border-light">
  <!-- Header -->
  <h2 class="text-center text-primary fw-bold mb-4">Payment Information</h2>

  <!-- Order Summary Card -->
  <div v-if="selectedPlan !== null" class="bg-light p-4 rounded-5 border shadow-sm mb-4">
    <h4 class="fw-semibold position-relative pb-2 mb-4 text-secondary">
      Order Summary
      <span class="position-absolute bottom-0 start-0 bg-primary divider-line"></span>
    </h4>

    <div class="d-flex justify-content-between align-items-center py-3 border-bottom small">
      <span class="text-muted">
        {{ membershipPlans[selectedPlan].name }} Plan
        ({{ membershipPlans[selectedPlan].billing_cycle?.name || '-' }})
      </span>
      <span class="fw-medium">
        R {{ Number(membershipPlans[selectedPlan].membership_pricing[0].price).toLocaleString('en-ZA', { minimumFractionDigits: 2 }) }}
      </span>
    </div>

    <div class="d-flex justify-content-between align-items-center pt-4 mt-2 fw-bold fs-5 text-secondary">
      <span>Total</span>
      <span>
        R {{ Number(membershipPlans[selectedPlan].membership_pricing[0].price).toLocaleString('en-ZA', { minimumFractionDigits: 2 }) }}
      </span>
    </div>
  </div>

  <!-- Navigation Buttons -->
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
    <button
      class="btn btn-secondary rounded-5 "
      @click="prevStep"
    >Back
    </button>

    <button
      class="btn btn-primary rounded-pill px-4 py-2 fw-semibold shadow-sm "
      @click="completePayment"
    >
      Subscribe
    </button>
  </div>

  <!-- Hidden Payment Form -->
  <form id="payment_form" :action="payfast" method="POST" class="d-none">
    <input type="submit" value="Submit" />
  </form>

  <input type="hidden" id="input_clone" class="d-none" />
</div>

    </div>
  </div>